<div>
    <div class="row" [ngClass]="{'disabled-div': modaleOpend}">

        <div *ngIf="event" class="col-3 details-background-color">
            <app-event-detail [event]="event" [site]="site" [vibrationRecords]="vibrationRecords"
                (callLoadAllRecords)="loadVibrationRecords()"></app-event-detail>
        </div>

        <div *ngIf="controlPoint" class="col-3 details-background-color">
            <app-control-point-detail [site]="site" [controlPoint]="controlPoint"
                [numeroContolPoint]="numeroContolPoint"></app-control-point-detail>
        </div>

        <div *ngIf="device" class="col-3 details-background-color">
            <app-device-detail [device]="device" [siteId]="siteId"></app-device-detail>
        </div>

        <div class="col-md-9">
            <div class="mt-2">
                <div style="display: inline-flex">
                    <div class="p-3" (click)="changerTab(1)" style="cursor: pointer;">
                        <strong [ngClass]="tab == 1 ? 'highlighted-div': ''"><img src="./icon/micro-records.svg" />
                            {{'MESSAGE_INFO.RECORDS' | translate}}
                        </strong>
                    </div>
                    <!-- <div *ngIf="device" class="p-3" (click)="changerTab(2)" style="cursor: pointer;">
                        <strong [ngClass]="tab == 2 ? 'highlighted-div': ''"><img src="./icon/notification.svg" />
                            {{'TRIGGER.TRIGGER_TRESHOLD' | translate}}
                        </strong>
                    </div> -->
                    <div *ngIf="device" class="p-3" (click)="changerTab(3)" style="cursor: pointer;">
                        <strong [ngClass]="tab == 3 ? 'highlighted-div': ''"><img src="./icon/settings.svg" />
                            {{'DEVICE_CONFIG.DEVICE_CONFIGURATION' | translate}}
                        </strong>
                    </div>
                    <div *ngIf="device || controlPointId || siteId" class="p-3" (click)="changerTab(4)" style="cursor: pointer;">
                      <strong [ngClass]="tab == 4 ? 'highlighted-div': ''"><img src="./icon/notification.svg" />
                          {{'SETTINGS.ALARM_CONFIGURATION' | translate}}
                      </strong>
                  </div>
                </div>
                <div *ngIf="tab == 1" class="border rounded-1 pt-2 mb-3 filter-container record-container"
                [ngClass]="totalRecords > 30 ? 'record-container-high' : ''" >
                    <div class="d-flex">
                      <div class="filter d-flex align-items-center">
                        <div class="d-flex align-items-center input-container me-3">
                          <input class="input-field" type="date"
                            placeholder="{{ 'PLACEHOLDERS.DATE_FORMAT' | translate }}"
                            [(ngModel)]="filterDate"
                            (ngModelChange)="onDateFilterChange($event)"
                            title="Filter date" />
                        </div>
                        <div class="form-check form-check-inline">
                          <input class="form-check-input" type="radio" name="typeRecord" id="option1" value="assigned" (change)="filterRecords(vibrationRecords,'assigned')">
                          <label class="form-check-label text-size" for="option1">
                            {{'MESSAGE_INFO.ASSIGNED_RECORDS' | translate}}
                          </label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input class="form-check-input" type="radio" name="typeRecord" id="option2" value="unAssigned" (change)="filterRecords(vibrationRecords,'unAssigned')">
                          <label class="form-check-label text-size" for="option2">
                            {{'MESSAGE_INFO.UNASSIGNED_RECORDS' | translate}}
                          </label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input class="form-check-input" type="radio" name="typeRecord" id="option3" value="all" (change)="filterRecords(vibrationRecords,'all')" checked>
                          <label class="form-check-label text-size" for="option3">
                            {{'MESSAGE_INFO.ALL' | translate}}
                          </label>
                        </div>
                      </div>
                      <div class="create d-flex justify-content-end new-record">
                        <button class="me-3 secondary-button multi-assignment" (click)="assignMultiRecords()"
                        [ngClass]="filteredRecords.length == 0 ? 'disabled-button' : ''"
                        [disabled]="filteredRecords.length == 0">
                          <img src="./icon/multi-assignment.svg" />
                          <span class="text-size"> {{'BUTTONS.MULTI_ASSIGNMENT' | translate}}</span>
                        </button>

                        <button class="me-3 primary-button" (click)="onRecordClick()">
                          <img src="./icon/plus.svg" />
                          <span class="text-size"> {{'BUTTONS.NEW_RECORD' | translate}}</span>
                        </button>
                      </div>
                    </div>
                    <div *ngIf="vibrationRecords != undefined" class="border-2 m-2 rounded-1">
                      
                      <app-record-detail [siteId]="siteId" [siteName]="site?.nom" [eventData]="event" [vibrationRecords]="filteredRecords" [selectedRecordId]="recordId"
                      [isDetailsVisible]="isDetailsVisible" [ponderations]="ponderations" [currentControlPoint]="controlPoint?.controlPointId" [currentDevice]="device" ></app-record-detail>
                      <div *ngIf="totalRecords > 2" class="footer-bar d-flex justify-content-center mt-3">
                        <nav aria-label="Page navigation">
                          <ul class="pagination">
                            <li class="page-item pe-2" [class.disabled]="currentPage === 1">
                              <a class="page-link" (click)="goToPage(1)" aria-label="First">
                                <span aria-hidden="true">««</span>
                              </a>
                            </li>
                            <li class="page-item pe-2" [class.disabled]="currentPage === 1">
                              <a class="page-link" (click)="goToPage(currentPage - 1)" aria-label="Previous">
                                <span aria-hidden="true">«</span>
                              </a>
                            </li>
                            <li *ngFor="let page of pages" class="page-item pe-2" [class.active]="currentPage === page">
                              <a class="page-link" (click)="goToPage(page)">{{ page }}</a>
                            </li>
                            <li class="page-item pe-2" [class.disabled]="currentPage === totalPages">
                              <a class="page-link" (click)="goToPage(currentPage + 1)" aria-label="Next">
                                <span aria-hidden="true">»</span>
                              </a>
                            </li>
                            <li class="page-item pe-2" [class.disabled]="currentPage === totalPages">
                              <a class="page-link" (click)="goToPage(totalPages)" aria-label="Last">
                                <span aria-hidden="true">»»</span>
                              </a>
                            </li>
                          </ul>
                        </nav>
                      </div>
                    </div>
                    <span  *ngIf="vibrationRecords == undefined || vibrationRecords.length == 0"  class="no-records text-size"> 
                      {{'VIBRATION.NO_RECORDS' | translate}}
                    </span>
                  </div>
                <ng-container *ngIf="tab == 2 ">
                    <app-trigger-threshold [siteId]="siteId" [serialNumber]="device.serialNumber">
                    </app-trigger-threshold>
                </ng-container>
                <ng-container *ngIf="tab == 3 ">
                    <app-device-config [formGroup]="deviceConfigForm" [deviceSerialNumber]="device.serialNumber" [siteId]="siteId"></app-device-config>
                </ng-container>
                <ng-container *ngIf="tab == 4 ">
                  <app-alarm-configuration [deviceConfigForm]="deviceConfigForm"  [controlPointId]="controlPointId"></app-alarm-configuration>
              </ng-container>


            </div>
        </div>
    </div>
</div>